import { ComponentType } from 'react';
import { FilterChipProps } from './common';
import { NumberRangeFilterChip } from './NumberRangeFilterChip';
import { ScaledNumberRangeFilterChip } from './ScaledNumberRangeFilterChip';
import { FilterType } from '../Primitives';
import { BaseFilterProps } from '../Primitives/common';
import { BinaryChoiceFilterChip } from './BinaryChoiceFilterChip';
import { StringSelectFilterChip } from './StringSelectFilterChip';
import { DateRangeFilterChip } from './DateRangeFilterChip';

export const FilterChipImplementations: Record<
  FilterType,
  ComponentType<FilterChipProps<BaseFilterProps<any, any>>>
> = {
  NumberRange: NumberRangeFilterChip,
  ScaledNumberRange: ScaledNumberRangeFilterChip,
  DateRange: DateRangeFilterChip,
  StringSelect: StringSelectFilterChip,
  BinaryChoice: BinaryChoiceFilterChip,
};
